import { z } from 'zod';
/**
 * Контракт эндпоинта `health`.
 *
 * Вход валидируется схемой, хотя параметров у проверки нет (сейчас —
 * ни одного): роут без схемы — это роут, про который забыли, что он
 * есть (security-checklist.md, п. 7). Схема `strict`, поэтому лишний
 * параметр — ошибка, а не тихо проигнорированное поле.
 */
export const healthInputSchema = z.strictObject({});
export const healthDependencySchema = z.strictObject({
    name: z.enum(['postgres', 'valkey']),
    ok: z.boolean(),
    latencyMs: z.number().int().nonnegative(),
    /** Текст ошибки без строки подключения: в ней логин и пароль. */
    error: z.string().optional(),
});
/**
 * Версия приложения и сборка, из которой оно поднято (D19).
 *
 * Версия одна на проект и живёт в корневом `package.json`; сюда она
 * попадает оттуда. Хеш коммита приходит из окружения сборки: там, где
 * его не передали (локальная разработка), стоит `dev` — выдумывать
 * хеш нельзя, а падать из-за его отсутствия не за что.
 */
export const buildInfoSchema = z.strictObject({
    version: z.string().regex(/^\d+\.\d+\.\d+$/, 'ожидается версия вида 0.0.1'),
    commit: z
        .string()
        .regex(/^([0-9a-f]{7,40}|dev)$/, 'ожидается короткий хеш коммита или dev'),
});
export const healthReportSchema = z.strictObject({
    /** `ok` — живы все зависимости; `degraded` — хотя бы одна мертва. */
    status: z.enum(['ok', 'degraded']),
    checkedAt: z.iso.datetime(),
    build: buildInfoSchema,
    dependencies: z.array(healthDependencySchema),
});
//# sourceMappingURL=health.js.map